import { Component } from '@angular/core';
import { NavController, NavParams, MenuController, AlertController } from 'ionic-angular';

import { TranslateService } from 'ng2-translate';

import { ProjectDetailsPage } from './project-details/project-details';
import { IProject, Project } from '../../model/top.model';

import { ProjectData } from '../../providers/project-data';

import { EditMode } from '../../enums/enums'
import { TimeRegistrationData } from '../../providers/time-registration-data';

@Component({
  selector: 'page-projects',
  templateUrl: 'projects.html'
})
export class ProjectsPage {
  private filterName: string;
  private projects: Array<IProject>;

  constructor(public navCtrl: NavController, public navParams: NavParams, public menuCtrl: MenuController, private alertCtrl: AlertController, private projectData: ProjectData, private timeRegistrationData: TimeRegistrationData, private translate: TranslateService) {
    menuCtrl.enable(true);
    this.projects = [];
    this.filterName = "";
  }

  ionViewWillEnter() {
    this.projectData.getProjects().then((result: Array<IProject>) => {
      this.projects = result;
    });
  }

  projectTapped(event, project) {
    this.navCtrl.push(ProjectDetailsPage, {
      project: project
    });
  }

  filterProjects() {
    this.projects = this.projectData.filterProjects(this.filterName);
  }

  addProject(event) {
    let newProject = new Project();
    this.navCtrl.push(ProjectDetailsPage, {
      project: newProject,
      editMode: EditMode.new
    });
  }

  deleteProject(event, project: IProject) {
    this.timeRegistrationData.findProjectTimeRegistrations(project.project_id).then(timeRegistrations => {
      if (timeRegistrations.length > 0) {
        let alert = this.alertCtrl.create({
          title: 'Kan niet verwijderen',
          subTitle: 'Op dit project staan uren geregistreerd',
          cssClass: 'tv-delete-alert',
          buttons: [{
            text: this.translate.instant('OK')
          }]
        });
        alert.present();
      } else {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('DELETE') + '?',
          subTitle: this.translate.instant('ARE_YOU SURE_DELETE', { value: '"' + project.name + '"' }) + '?',
          cssClass: 'tv-delete-alert',
          buttons: [{
            text: this.translate.instant('NO')
          },
          {
            text: this.translate.instant('YES'),
            handler: data => {
              this.projectData.deleteProject(project).then((result: Array<IProject>) => {
                // console.log(result);
              });
            }
          }]
        });
        alert.present();
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/projects.ts